<div class="panel panel-default col-sm-5" style="margin-left: 100px; display: none" id="settingsLocate">
  <div class="panel-heading">Map Settings</div>

  <div class="panel-body">

    <form class="form-horizontal">
      <div class="form-group">
        <div class="col-sm-12"><h6>DEFAULT VALUES WHEN VIEWING MAP</h6></div>
        <label class="control-label col-sm-3">ASSETS</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="assets" id="assets" [checked]="assets" (click)="assetsClicked()" class="styled"><label for="space"></label></div></div>
        <label class="control-label col-sm-4"></label>
        <div class="col-sm-2"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">PEOPLE</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="people" id="people" [checked]="people" (click)="peopleClicked()" class="styled"><label for="space"></label></div></div>
        <label class="control-label col-sm-4"></label>
        <div class="col-sm-2"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">PERIMETERS</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="perimeters" id="perimeters" [checked]="perimeters" (click)="perimetersClicked()" class="styled"><label for="space"></label></div></div>
        <label class="control-label col-sm-4"></label>
        <div class="col-sm-2"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">BREADCRUMBS</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="breadcrumbs" id="breadcrumbs" [checked]="breadcrumbs" (click)="breadcrumbsClicked()" class="styled"><label for="space"></label></div></div>
        <label class="control-label col-sm-4"></label>
        <div class="col-sm-2"></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">ZONES</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="zones" id="zones" [checked]="zones" (click)="zonesClicked()" class="styled"><label for="space"></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">ZONE NAMES</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="zoneNames" id="zoneNames" [checked]="zoneNames" (click)="zoneNamesClicked()" class="styled"><label for="space"></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">SUBLOCATIONS</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="sublocations" id="sublocations" [checked]="sublocations" (click)="sublocationsClicked()" class="styled"><label for="space"></label></div></div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3">SUBLOCATION NAMES</label>
        <div class="col-sm-2"><div class="checkbox checkbox-inline"><input type="checkbox" name="sublocationNames" id="sublocationNames" [checked]="sublocationNames" (click)="sublocationNamesClicked()" class="styled"><label for="space"></label></div></div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateSettingsLocate()"><i class="fa fa-refresh" aria-hidden="true"></i> UPDATE</button>
      </div>

    </form>
  </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
